import { createSvgIcon } from '@material-ui/core';

export const YellowFlagIcon = createSvgIcon(
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M29.6081 9.47088C29.1406 9.47088 28.7354 9.14693 28.6326 8.69085L27.9762 5.78003C27.8734 5.32395 27.4682 5 27.0007 5H6C5.44771 5 5 5.44772 5 6V42C5 42.5523 5.44772 43 6 43H9.06711C9.61939 43 10.0671 42.5523 10.0671 42V28.3528C10.0671 27.8005 10.5148 27.3528 11.0671 27.3528H23.4549C23.9221 27.3528 24.327 27.6762 24.4302 28.1318L25.0903 31.0446C25.1935 31.5002 25.5984 31.8236 26.0655 31.8236H42C42.5523 31.8236 43 31.3759 43 30.8236V10.4709C43 9.91859 42.5523 9.47088 42 9.47088H29.6081Z"
      fill="#F9A825"
    />
  </svg>,
  'YellowFlagIcon',
);
